module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Medium.6a3a35b.woff2";